module.exports = __webpack_public_path__ + "down.png?b002db13dea263ad509f56bfb0b375bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down.png
// module id = 179
// module chunks = 2